
import React from "react";

export const CourseDetailInstructor = ({
  name = "Kaija Alliksaar",
  image = "/images/received_251291397735991-01.jpeg",
  bio = 'ICF sertifitseeritud traumateadlik somaatiline enesejuhtimise coach, kellel on üle 15 aasta juhtimiskogemust.'
}) => (
  <div className="flex items-start gap-4">
    <img src={image} alt={name} className="w-20 h-20 rounded-full object-cover" />
    <div>
      <div className="font-semibold">{name}</div>
      <div className="text-gray-600 text-sm">{bio}</div>
      <div className="text-gray-600 text-sm italic mt-2">
        „Usun, et muutus algab sellest, kui õpime mõistma oma keha, reaktsioone ja vajadusi. See on võti sisemise rahu ja selguse juurde."
      </div>
    </div>
  </div>
);
